import { message, Table, Button, Form, Card, Tabs, Space, Input, Select, Divider, Descriptions } from "antd";
import { useEffect, useRef, useState } from "react";
import useWebPost from "../../utils/useWebPost";
import FullHeightLayout from '../../components/FullHeightLayout';
import { checkp } from '../../utils/functions'
import CustModal from "../../components/ShowModal";
import DateSelector from '../../components/DateSelector';
import ImgUploader from "../../components/ImgUploader";
import renderFileList from "../../components/renderFileList";

const { Option } = Select;

function Pjlist() {
    const webPost = useWebPost();
    const [modalVisible, setModalVisible] = useState('');
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const [freshData, setfreshData] = useState(null);
    const [filters, setFilters] = useState({});
    const [dates, setDates] = useState({});
    const [activeKey, setActiveKey] = useState('1');

    const [form] = Form.useForm();
    const [editingRecord, setEditingRecord] = useState(null);

    const [szList, setszList] = useState(null);
    const [szList2, setszList2] = useState(null);

    const loadingRef = useRef();
    useEffect(() => {
        const fetchItems = async () => {
            if (loadingRef.current) return;
            loadingRef.current = true;
            setLoading(true);
            let res = [];
            try {
                const params = { s: activeKey, ...filters, ...dates };
                const response = await webPost('pjscb', params);
                if (response) {
                    res = response;
                }
            } finally {
                loadingRef.current = false;
                setLoading(false);
            }
            setData(res);
        }
        fetchItems();
    }, [freshData, activeKey]);

    const columns = [
        {
            title: '序号', dataIndex: 'xd', width: 80, fixed: 'left',
            render: (text, record, rowIndex) => {
                return rowIndex + 1;
            },
        },
        { title: '项目名称', dataIndex: 'xmmc', width: 320 },
        { title: '制单人', dataIndex: 'maker_name', width: 100 },
        { title: '制单日期', dataIndex: 'make_date', width: 120 },
        { title: '出款金额', dataIndex: 'this_receipt_amount', width: 140 },
        { title: '收款单位', dataIndex: 'payer_name', width: 120 },
        { title: '收款账号', dataIndex: 'payer_account', width: 160 },
        (checkp(['cwinv']) || checkp(['cwckpz'])) && {
            title: '操作',
            key: 'action',
            width: 160,
            fixed: 'right',
            render: (_, record) => <Button type="link" onClick={() => showModal(record, "scbs")} >上传出款凭据</Button>,
        },
    ].filter(Boolean);
    const columns2 = [
        {
            title: '序号', dataIndex: 'xd', width: 80, fixed: 'left',
            render: (text, record, rowIndex) => {
                return rowIndex + 1;
            },
        },
        { title: '项目名称', dataIndex: 'xmmc' },
        { title: '制单人', dataIndex: 'maker_name' },
        { title: '制单日期', dataIndex: 'make_date' },
        { title: '发票金额（含税）', dataIndex: 'amount' },
        { title: '开票税率', dataIndex: 'kpsl' },
        { title: '买方单位', dataIndex: 'mf_dw' },
        { title: '发票号', dataIndex: 'invoice_no' },
        (checkp(['cwinv']) || checkp(['cwckpz'])) && {
            title: '操作',
            key: 'action',
            width: 160,
            fixed: 'right',
            render: (_, record) => <Button type="link" onClick={() => showModal(record, "sczq")} >上传债权凭据</Button>,
        },
    ].filter(Boolean);

    const showModal = async (record = null, action) => {
        if (!record) {
            message.error("错误的参数");
            return;
        }
        setModalVisible(action);
        form.setFieldsValue(record);
        setEditingRecord(record);
        const res = await webPost('getCkzcList', { id: record.id });
        if (res) {
            if (res?.ly && res.ly.length === 0) {
                setszList(null);
            } else {
                setszList(res.ly);
            }
            if (res?.fl && res.fl.length === 0) {
                setszList2(null);
            } else {
                setszList2(res.fl);
            }
        }
    };

    const handleModalClose = () => {
        setModalVisible('');
        setEditingRecord(null);
    }
    const saveSubmit = async () => {
        const values = await form.validateFields();
        const params = {
            id: editingRecord.id, ...values, s: activeKey
        };
        const res = await webPost('scbsSave', params);
        if (res) {
            message.success('保存成功');
            setfreshData(Math.random()); //强制刷新数据
            handleModalClose();
        }
    }

    return (
        <FullHeightLayout
            headerContent={
                <Space size="middle">
                    <DateSelector onChange={(v) => { setDates(v); }} />
                    <Select placeholder='类型' style={{ width: '120px' }} onChange={(v) => setFilters(prev => ({ ...prev, "lx": v }))}>
                        <Option value='1'>项目名称</Option>
                        <Option value='2'>项目编号</Option>
                        <Option value='3'>制单人</Option>
                        <Option value='4'>科目代码</Option>
                        <Option value='5'>金额</Option>
                    </Select>
                    <Input onChange={(e) => setFilters(prev => ({ ...prev, 'key': e.target.value }))} />
                    <Button type="primary" onClick={() => setfreshData(Math.random())} >搜索</Button>
                </Space>
            }
            footerContent={null}
        >
            <Tabs activeKey={activeKey} onChange={setActiveKey}>
                <Tabs.TabPane tab='出款凭据' key="1"></Tabs.TabPane>
                <Tabs.TabPane tab='债权登记凭据' key="2"></Tabs.TabPane>
            </Tabs>
            <Table
                columns={activeKey === '1' ? columns : columns2}
                dataSource={data}
                rowKey='id'
                loading={loading}
                pagination={false}
                bordered
                scroll={{
                    x: 1400,
                    y: 'calc(100vh - 300px)',
                }}
                tableLayout="fixed"
            />
            <CustModal
                title={'上传出款凭据'}
                open={modalVisible === 'scbs'}
                onCancel={handleModalClose}
                onOk={saveSubmit}
                okText="保存凭据"
                cancelText="取消"
            >
                <Form form={form}>
                    <Divider titlePlacement="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                        付款来源信息
                    </Divider>
                    {szList && <Table rowKey="id" dataSource={szList} footer={null} pagination={false} columns={[
                        {
                            title: '支付来源', dataIndex: 'ps', render: (t) => {
                                if (t.includes('个人来款')) {
                                    return '个人来款';
                                }
                                if (t.includes('建设单位来款')) {
                                    return '建设单位来款';
                                }
                                if (t.includes('资金垫付')) {
                                    return '资金垫付';
                                }
                            }
                        },
                        {
                            title: '来源对象(日期-科目-当前余额)', dataIndex: 'ps', render: (_, it) => {
                                if (it.ps.includes('资金垫付')) {
                                    return `${it.kmmc}-${it.left_amount}`;
                                }
                                return `${it.make_date}-${it.kmmc}-${it.left_amount}`;
                            }
                        },
                        { title: '支付金额', dataIndex: 'amount' },
                        { title: '银行账号', dataIndex: 'account' },

                    ]} ></Table>
                    }
                    {szList2 && <>
                        <Divider titlePlacement="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                            资金分流信息
                        </Divider>
                        <Table rowKey="id" dataSource={szList2} footer={null} pagination={false} columns={[
                            { title: '转入项目', dataIndex: 'xmmc', render: (t, rs) => `${rs.sn}……${rs.xmmc}` },
                            { title: '科目', dataIndex: 'ps', render: (_, it) => `${it.km}-${it.kmmc}` },
                            { title: '转入金额', dataIndex: 'this_receipt_amount' },
                            { title: '银行账号', dataIndex: 'account' },

                        ]} ></Table>
                    </>}
                    <Divider titlePlacement="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                        收款方信息
                    </Divider>
                    <Descriptions>
                        <Descriptions.Item label="收款户名">{editingRecord?.payer_name}</Descriptions.Item>
                        <Descriptions.Item label="收款账号">{editingRecord?.payer_account}</Descriptions.Item>
                        <Descriptions.Item label="收款银行">{editingRecord?.payer_bank}</Descriptions.Item>
                    </Descriptions>
                    <Divider titlePlacement="left" style={{ fontSize: 16, fontWeight: 'bold' }}>
                        备注信息
                    </Divider>
                    <Descriptions>
                        <Descriptions.Item label="备注">{editingRecord?.remark}</Descriptions.Item>
                    </Descriptions>
                    <Descriptions>
                        <Descriptions.Item label="审核1备注">{editingRecord?.remark1}</Descriptions.Item>
                    </Descriptions>
                    <Descriptions>
                        <Descriptions.Item label="审核2备注">{editingRecord?.remark2}</Descriptions.Item>
                    </Descriptions>
                    <br />
                    {editingRecord?.attachment && editingRecord?.attachment.length > 0 && (
                        <>
                            <Divider titlePlacement="left" style={{ marginTop: 24 }}>附件</Divider>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
                                {renderFileList(editingRecord?.attachment)}
                            </div>
                        </>
                    )}
                    <br />
                    <Form.Item name='attachment2' label="上传出款凭据"><ImgUploader /></Form.Item>
                </Form>
            </CustModal>
            <CustModal
                title={'上传出款凭据（其它税额和个人所得税可不填，其它都填完才算完成） '}
                open={modalVisible === 'sczq'}
                onCancel={handleModalClose}
                onOk={saveSubmit}
                okText="保存凭据"
                cancelText="取消"
            >
                <Form form={form}>
                    <Card key={`wjz`} title={`外经证`}>
                        <div className="responsive-grid2">
                            <Form.Item label="外经证" name="files2"><ImgUploader /></Form.Item>
                            <Form.Item label="反馈表" name="files3"><ImgUploader /></Form.Item>
                        </div>
                    </Card>
                    <Card key={`wszm`} title={`完税证明`}>
                        <div className="responsive-grid2">
                            <Form.Item label="预缴增值税" name="files4"><ImgUploader /></Form.Item>
                            <Form.Item label="预缴企业所得税" name="files5"><ImgUploader /></Form.Item>
                            <Form.Item label="其它税额" name="files6"><ImgUploader /></Form.Item>
                            <Form.Item label="个人所得税" name="files7"><ImgUploader /></Form.Item>
                        </div>
                    </Card>
                    <Card key={`wsfp`} title={`发票`}>
                        <div className="responsive-grid2">
                            <Form.Item label="发票" name="files8"><ImgUploader /></Form.Item>
                        </div>
                    </Card>
                </Form>
            </CustModal>
        </FullHeightLayout>
    )
}


export default Pjlist;
